import { create } from "zustand";
import type { MapData } from "../types/MapData.types";

type LoadingTracker = {
  allLoaded: boolean;
  loadingProgress: number;
  loadedItems: number;
  totalItems: number;
};

export const useUI = create<{
  currentMap: string | null;
  setCurrentMap: (map: string | null) => void;
  loadingTracker: LoadingTracker;
  initializeLoadingTracker: () => void;
  registerMapDataItems: (mapData: MapData) => void;
  resetLoadingTracker: () => void;
  markItemLoaded: () => void;
  startGame: boolean;
  setStartGame: (start: boolean) => void;
  hoveredMapId: string | null;
  setHoveredMapId: (mapId: string | null) => void;
  globePosition: { x: number; y: number; };
  setGlobePosition: (position: { x: number; y: number; }) => void;
  setLoadingProgress: (progress: number) => void;
  statsPopupIsOpen: boolean;
  setStatsPopupIsOpen: (statsPopupIsOpen: boolean) => void;
}>((set) => ({
  statsPopupIsOpen: false,
  setStatsPopupIsOpen: (statsPopupIsOpen: boolean) => set({ statsPopupIsOpen: statsPopupIsOpen }),
  currentMap: null,
  setCurrentMap: (map: string | null) => set({ currentMap: map }),
  loadingTracker: {
    allLoaded: false,
    loadingProgress: 0,
    loadedItems: 0,
    totalItems: 0,
  },
  startGame: false,
  setStartGame: (start: boolean) => set({ startGame: start }),
  hoveredMapId: null,
  setHoveredMapId: (mapId: string | null) => set({ hoveredMapId: mapId }),
  globePosition: { x: 0, y: 0 },
  setGlobePosition: (position: { x: number; y: number; }) => set({ globePosition: position }),
  initializeLoadingTracker: () =>
    set({
      loadingTracker: {
        allLoaded: false,
        loadingProgress: 0,
        loadedItems: 0,
        totalItems: 0,
      },
      startGame: false,
    }),
  resetLoadingTracker: () => set({ loadingTracker: {
    allLoaded: false,
    loadingProgress: 0,
    loadedItems: 0,
    totalItems: 0,
  }}),
  registerMapDataItems: (mapData: MapData) => {
    const uniqueUrls = new Set<string>();
    mapData.terrain.objects.forEach((object) => {
      uniqueUrls.add(object.modelURL);
    });
    mapData.npcs.forEach((npc) => {
      uniqueUrls.add(npc.modelURL);
    });
    uniqueUrls.add(mapData.terrain.ground.textureUrl);
    const totalItems = uniqueUrls.size;
    set((state) => ({
      loadingTracker: {
        ...state.loadingTracker,
        totalItems,
      },
    }));
  },

  markItemLoaded: () => {
    set((state) => ({
      loadingTracker: {
        ...state.loadingTracker,
        loadedItems: state.loadingTracker.loadedItems + 1,
      },
    }));
  },
  setLoadingProgress: (progress: number) => set((state) => ({ loadingTracker: { ...state.loadingTracker, loadingProgress: progress } })),
}));